import UnForm from "../../../../Components/Form";
import { contentTypes } from "../../../../mocks/contentTypeTwilio";
import "./styles.css";

interface ContentTypeSelectorProps {
    selectedType: string;
    onSelectType: (type: string) => void;
}

export default function ContentTypeSelector(props: ContentTypeSelectorProps) {
    const { selectedType, onSelectType } = props;

    return (
        <div className="mt-15">
            <label>Selecione o tipo de conteúdo</label>
            <div className="d-flex flex-wrap">
                <div className="form-group d-flex flex-column mr-4 w-50">
                    {contentTypes.map((type) => (
                        <div
                            key={type.value}
                            className={`hover-effect mb-3 p-3 border rounded d-flex align-items-center justify-content-between ${
                                selectedType === type.value
                                    ? "bg-light-primary text-white border-primary"
                                    : "bg-light"
                            }`}
                            onClick={() => onSelectType(type.value)}
                        >
                            <label className="m-0" htmlFor={type.value}>
                                {type.label}
                            </label>
                            <UnForm.Input
                                className="ml-auto"
                                type="radio"
                                name="contentType"
                                id={type.value}
                                value={type.value}
                                checked={selectedType === type.value}
                                onChange={() => onSelectType(type.value)}
                                required
                            />
                        </div>
                    ))}
                </div>
                {selectedType && (
                    <div className="border border-light rounded p-4 w-25">
                        <h2>
                            {
                                contentTypes.find(
                                    (type) => type.value === selectedType
                                )?.label
                            }
                        </h2>
                        <img
                            src={
                                contentTypes.find(
                                    (type) => type.value === selectedType
                                )?.imgSrc
                            }
                            alt={selectedType}
                            className="img-fluid mt-2"
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
